import { WebHeader } from './WebHeader';
export default WebHeader;
